import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import ResponseHandler from './AxiosWrapper';
import { AuthenticationProvider } from './views/dss/AuthenticationProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <GoogleOAuthProvider clientId='949770729633-vdatl2mhomdqmqmdvo5oi5rkqllmdjl0.apps.googleusercontent.com'>
   <AuthenticationProvider>
    <ThemeProvider theme={theme}>
      <ResponseHandler>
      <App />
    </ResponseHandler>
    </ThemeProvider>
    </AuthenticationProvider>
    </GoogleOAuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
